import api from './api';
import types from './mutation-types';
import moment from 'moment';
import utils from '@/utils';
import { number } from 'yup';

function getRowKey() {
	return moment.now().toString();
}

export default {
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setStatePopupInit_({ commit }) {
		commit(types.STATE_POPUP_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SET_SEARCH_PARAM, { key, value });
	},
	setSearchPopupMParam_({ commit }, { key, value }) {
		commit(types.SET_SEARCH_POPUP_M_PARAM, { key, value });
	},
	setSearchPopupMPagingInfo_({ commit }, { key, value }) {
		commit(types.SEARCH_POPUP_M_PAGING_INFO, { key, value });
	},
	setSearchPopupDParam_({ commit }, { key, value }) {
		commit(types.SET_SEARCH_POPUP_D_PARAM, { key, value });
	},
	setCurrentMstValue_({ commit }, param) {
		commit(types.DEFAULT_ASSIGN, { key: 'currentMstValue', value: param });
		// commit(types.SET_CURRENT_MST_VALUE, { partNo: partNo });
	},

	setPopupDataList_({ commit }, { key, value }) {
		commit(types.SET, { key, value });
	},
	setPopupDataMstListInit({ commit }) {
		commit(types.POPUP_DATA_MST_LIST_INIT);
	},
	setPopupDataDtlListInit({ commit }) {
		commit(types.POPUP_DATA_DTL_LIST_INIT);
	},

	/**call API */
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);
			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	async getCommCodeDetails_({ commit }, { key, codeType }) {
		try {
			//const { altrPrvsLgrpCd, altrPrvsSgrpCd } = state.detailForm;
			const { header, body } = await api.getCommCodeDetails(codeType);

			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body.resultList });
				// if (body.resultList.length) {
				// 	commit(types.DETAIL_FORM, { key: 'isirCsetScnCd', value: body.resultList[0].cdDesc });
				// } else {
				// 	commit(types.DETAIL_FORM, { key: 'isirCsetScnCd', value: '20' });
				// }
			} else if (header.code === 3) {
			}
			return header;

			// const { header, body } = await api.getCommCodeDetails(codeType);
			// if (header.code === 0) {
			// 	const list = [];
			// 	body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
			// 	await commit(types.DEFAULT_ASSIGN, { key, value: list });
			// } else if (header.code === 3) {
			// }
			// return header;
		} catch (error) {
			return error.header || error;
		}
	},
	async getPartCkuMstList_({ commit, state }, pagination) {
		const pagingInfo = { ...state.masterPagingInfo, ...pagination };
		return await api
			.getPartCkuMstList({ ...state.searchParams, ...pagingInfo })
			.then(data => {
				// console.log('data >>> ', data);
				if (data.header.code === 0) {
					const { pagingInfo, resultList } = data.body;
					resultList.forEach(row => delete row.totalSize);
					commit(types.SET, { key: 'masterList', value: resultList });
					//commit(types.SET, { key: 'masterPagingInfo', value: pagingInfo });
					commit(types.SET, { key: 'detailList', value: [] });
					commit(types.SET, { key: 'currentMsterValue', value: '' });
				} else {
					throw new Error(data.header.message);
				}
			})
			.catch(error => {
				// console.log('error >>> ', error.header || error);
				throw error.header || error;
			});

		// try {
		// 	const pagingInfo = { ...state.masterPagingInfo, ...pagination };
		// 	const data = await api.getPartCkuMstList({ ...state.searchParams, ...pagingInfo });
		// 	console.log('data', data);
		// 	if (data.header.code === 0) {
		// 		const { pagingInfo, resultList } = data.body;
		// 		resultList.forEach(row => delete row.totalSize);
		// 		commit(types.SET, { key: 'masterList', value: resultList });
		// 		commit(types.SET, { key: 'masterPagingInfo', value: pagingInfo });
		// 		commit(types.SET, { key: 'detailList', value: [] });
		// 		commit(types.SET, { key: 'currentMsterValue', value: '' });
		// 	} else if (data.header.code === 3) {
		// 		throw new Error(data.header.message);
		// 	}
		// 	return data.header;
		// } catch (error) {
		// 	return error.header || error;
		// }
	},
	//
	async getPartCkuDelList_({ commit, state }, payload) {
		const { partNo, ckuPrvsCd, prvsClCd, init, currentPage = 1, pageUnit = 10 } = payload;
		return api
			.getPartCkuDtlList({ partNo, ckuPrvsCd, prvsClCd, currentPage, pageUnit })
			.then(({ body: { resultList, pagingInfo }, header }) => {
				resultList.forEach(row => delete row.totalSize);
				commit(types.SET, { key: 'detailList', value: resultList });
				commit(types.SET, { key: 'detailPagingInfo', value: pagingInfo });
				return resultList;
			})
			.catch(e => console.error(e));
	},

	//마스터 목록에서 추가버튼 클릭시
	addMasterRow_({ state, commit }) {
		const rowKey = getRowKey();
		const addedRow = {
			ckuPrvsCd: '',
			prvsClCd: '',
			prvsClNm: '',
			ckuWayCd: '',
			nrmLlmtVal: null,
			nrmUplmVal: null,
			spcRslt: '',
			utmCd: '',
			sort: '',
			useYn: 'Y',
			rowStatus: 'I',
			rowKey
		};
		const value = [...state.masterList, addedRow];
		commit(types.SET, { key: 'masterList', value });
		return addedRow;
	},
	// 마스터 목록에서 저장
	async saveMaster_(store, { partNo, saveRows }) {
		try {
			const { header } = await api.saveMaster({ partNo, saveRows });
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	// 마스터 목록에서 삭제
	async deleteMaster_(store, { partNo, delRows }) {
		try {
			const { header } = await api.deleteMaster({ partNo, delRows });
			return header;
		} catch (error) {
			//return error.header || error;
			throw new Error(error.header.message || error);
		}
	},
	// 디테일 목록에서 추가버튼 클릭시
	addDetailRow_({ state, commit }, mstValues) {
		const rowKey = getRowKey();
		const addedRow = {
			partNo: mstValues.partNo,
			ckuPrvsCd: mstValues.ckuPrvsCd,
			prvsClCd: mstValues.prvsClCd,
			prvsClNm: mstValues.prvsClNm,
			jgmtCrtnCd: '',
			jgmtMinVal: null,
			jgmtMaxVal: null,
			jgmtNm: '',
			sort: '',
			useYn: 'Y',
			rowKey
		};

		const value = [...state.detailList, addedRow];
		commit(types.SET, { key: 'detailList', value });
		return addedRow;
	},
	// 디테일 목록에서 저장
	async saveDetail_(store, { mstParams, saveRows }) {
		try {
			const data = await api.saveDetail({ mstParams, saveRows });
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	},
	// 디테일 목록에서 삭제
	async deleteDetail_(store, { mstParams, delRows }) {
		try {
			const data = await api.deleteDetail({ mstParams, delRows });
			return data.header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	},
	/* 팝업관련 시작 */
	async getPopupMList_({ commit, state }) {
		const { searchPopupMParams, searchPopupMPagingInfo } = state;

		return api
			.getPopupMasterList({
				searchParams: searchPopupMParams,
				currentPage: searchPopupMPagingInfo.currentPage,
				pageUnit: searchPopupMPagingInfo.pageUnit
			})
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET, {
						key: 'masterPopupList',
						value: data?.body.resultList || []
					});
					commit(types.SET, {
						key: 'searchPopupMPagingInfo',
						value: data?.body.pagingInfo
					});
					commit(types.SET, {
						key: 'detailPopupList',
						value: []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	async getPopupDList_({ commit, state }, partNo) {
		return api
			.getPopupList({ partNo })
			.then(({ body: { resultList }, header }) => {
				resultList.forEach(row => delete row.totalSize);
				commit(types.SET, { key: 'detailPopupList', value: resultList });

				return resultList;
			})
			.catch(e => console.error(e));
	},
	// 부품검사 복사저장
	async savePopupList_(store, { partNo, saveRows }) {
		try {
			const { header } = await api.savePopupList({ partNo, saveRows });
			return header;
		} catch (error) {
			throw new Error(error.header.message || error);
			// console.log('error >>> ', error);
			// return error.header || error;
		}
	},
	setDetailInit_({ commit }) {
		commit(types.SET, { key: 'detailList', value: [] });
	},
	//엑셀템플릿 다운
	async excelTempDown_(store, params) {
		try {
			const response = await api.excelTempDown(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			throw new Error(error?.header);
		}
	},
	// Cpk기본설정 항목으로 진행
	async saveCpkDef_(store, { mstParams, params }) {
		try {
			const data = await api.saveCpkDef_({ mstParams, params });
			return data.header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	}
};
